<script>
  import {getContext} from 'svelte';
  import {PATHS} from '@/const/paths';
  import {sd} from '@/da';
  import {fixLink$} from '@/store/lang';
  import {web3ModuleState$} from '@/modules/web3/stream';
  import {isSupportLending$} from '@/streams/lending/state';
  import MenuItemView from '../components/MenuItemView.svelte';
  import lang from '../../Header.lang';

  const LG = getContext('LG');
  let items = [];

  $: updateItems($web3ModuleState$, $isSupportLending$);

  function updateItems(web3ModuleState, isSupportLending) {
    items = [
      {
        iconUrl: 'https://img.phemex.com/v1/cdb8b20c-26e0-4c77-8be5-1449513c930c/property-1-phemex-pulse.svg',
        iconAlt: 'phemex_plus',
        link: $fixLink$(PATHS.WEB3_PULSE_HOME.pathname),
        titleIcon: 'https://img.phemex.com/v1/fb7fb441-6fab-4400-92b0-846286eb5cb1/hot.svg',
        target: '_self',
        title: LG(lang.SocialTrade),
        subTitle: LG(lang.PhemexAllInOne),
        trackClick: handleWebClickFuc('phemex_plus'),
        hidden: false,
      },
      {
        iconUrl: 'https://img.phemex.com/v1/86ebae0c-b3e8-41c3-bde4-ab627b6d6d6a/property-1-pt-staking.svg',
        iconAlt: 'web3_stake',
        link: $fixLink$(PATHS.WEB3_STAKE.pathname),
        titleIcon: null,
        target: '_self',
        title: LG(lang.Web3PTStaking),
        subTitle: LG(lang.Web3PTStakingDesc),
        trackClick: handleWebClickFuc('web3_stake'),
        hidden: !web3ModuleState,
      },
      {
        iconUrl: 'https://img.phemex.com/v1/6d0763e7-3ff0-428e-90a7-9f7542b60a74/property-1-welcome-to-phemexia.svg',
        iconAlt: 'phemexia',
        link: $fixLink$(PATHS.PHEMEXIA.pathname),
        titleIcon: null,
        target: '_self',
        title: LG(lang.Phemexia),
        subTitle: LG(lang.PhemexiaDesc),
        trackClick: handleWebClickFuc('phemexia'),
        hidden: false,
      },
      {
        iconUrl: 'https://img.phemex.com/v1/60ff1efa-fce6-4b2e-94b4-a06054fa6ac3/property-1-phemex-soul-pass.svg',
        iconAlt: 'soul_pass',
        link: $fixLink$(PATHS.WEB3_SOUL_PASS.pathname),
        titleIcon: null,
        target: '_self',
        title: LG(lang.Web3SoulPass),
        subTitle: LG(lang.Web3SoulPassDesc),
        trackClick: handleWebClickFuc('soul_pass'),
        hidden: !web3ModuleState,
      },
      {
        iconUrl: 'https://img.phemex.com/v1/ba4723d0-a568-4bbc-be7a-3db249a7a036/property-1-phemex-token-benefit.svg',
        iconAlt: 'token',
        link: $fixLink$(PATHS.WEB3_EQUITY_BENEFITS.pathname),
        titleIcon: null,
        target: '_self',
        title: LG(lang.Web3Token),
        subTitle: LG(lang.Web3TokenDesc),
        trackClick: handleWebClickFuc('token'),
        hidden: !web3ModuleState,
      },
      {
        iconUrl: 'https://img.phemex.com/v1/1b2e0bd4-fac8-4b84-b9ab-d43f9f8778c0/property-1-phemex-lending.svg',
        iconAlt: 'web3_stake',
        link: $fixLink$(PATHS.WEB3_LENDING_MARKET.pathname),
        titleIcon: 'https://img.phemex.com/v1/c80564dc-92f8-4e33-bcd6-a9e383b8857d/new.svg',
        target: '_self',
        title: LG(lang.Web3LendingProtocol),
        subTitle: LG(lang.Web3LendingProtocolDesc),
        trackClick: handleWebClickFuc('lending_protocol'),
        hidden: !isSupportLending,
      },
    ].filter((r) => !r.hidden);
  }

  function handleWebClickFuc(item) {
    return function () {
      sd.track('web_click', {$screen_name: 'home', $element_content: 'navigation_web3_' + item});
    };
  }
</script>

<style>
  .wrap {
    box-sizing: border-box;
    padding: 16px;
    width: 328px;
    background: rgba(26, 29, 31, 0.96);
    backdrop-filter: blur(10px);
    cursor: default;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
</style>

<div class="wrap df fdc T2 ovh">
  {#each items as item}
    <MenuItemView
      theme="dark"
      iconUrl={item.iconUrl}
      iconAlt={item.iconAlt}
      link={item.link}
      target={item.target}
      title={item.title}
      subTitle={item.subTitle}
      titleIcon={item.titleIcon}
      on:click={item.trackClick}
      noArrow
    />
  {/each}
</div>
